import React, { useState } from "react";
import TextInput from "../components/TextInput"; // Assuming TextInput is a reusable component
import API from "../config/config";
import { useNavigate } from "react-router-dom";

const AddAdmin = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: "",
    emailId: "",
    phone: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    try {
      const token = localStorage.getItem("adminToken");
      const response = await fetch(API.ADMIN.ADMINS_ADD, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        navigate("/admins");
      } else {
        console.error("Failed to save admin");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="flex items-center justify-center -mt-12 px-4 bg-gray-100 min-h-screen">
      <form
        className="w-full bg-white shadow-lg rounded-lg p-4"
        onSubmit={handleSubmit}
      >
        <h2 className="text-2xl font-bold text-center mb-1">Add Admin</h2>
        <hr className="mb-3" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <TextInput
            name="fullName"
            label="Name"
            value={formData.fullName}
            onChange={handleChange}
            className="w-full"
            required={true}
          />

          <TextInput
            name="emailId"
            label="Email"
            value={formData.emailId}
            onChange={handleChange}
            className="w-full"
            required={true}
          />
          <TextInput
            name="phone"
            label="Phone"
            value={formData.phone}
            onChange={handleChange}
            className="w-full"
            required={true}
          />
          <TextInput
            name="password"
            label="Password"
            value={formData.password}
            onChange={handleChange}
            className="w-full"
            type="password"
            required={true}
          />
        </div>
        <button
          type="submit"
          className="mt-4 w-1/4 bg-yellow-300 text-white font-semibold py-3 rounded-lg hover:bg-blue-700 transition-colors duration-300"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default AddAdmin;
